<template>
  <section v-if="sections.length > 0" class="sections">
    <template v-for="(section,index) in sections">
      <paragraph :section="section" :index="index" :sizes="sizes" :key="nid + '_' +index"></paragraph>
    </template>
  </section>
</template>
<script>
import Paragraph from './Paragraph.vue'

export default {
  props: {
    sections: {
      type: Array,
      default: function () {
        return []
      }
    },
    sizes: {},
    nid: 0
  },
  data: function () {
    return {
      mediaPlaying: ''
    }
  },
  created: function () {
    this.mediaPlaying = this.$parent.mediaPlaying
  },
  components: {
    Paragraph
  }
}
</script>


// WEBPACK FOOTER //
// Paragraphs.vue?57d971d2